import {
	ARTICLE_SOURCES_FACET,
	CA_SHOW_ALTERNATIVES_ALWAYS,
	CA_SHOW_CUSTOMER_ARTICLE_GROUPING_LINK,
	CA_USE_METROX_ACCOUNT_FLYOUT,
	CI_ARTICLE_BANNER,
	CI_BLOCK_OLD_TERMS_AND_CONDITIONS_PAGE,
	CI_ENABLE_BANNER_FLAVOR,
	CI_ENABLE_BANNER_GIFS,
	CI_MULTIPLE_CREATIVES,
	CI_NEW_FOOTER,
	CI_NEW_STORELIST_PAGE,
	CI_SL_CASH_AND_CARRY_VISIBLE,
	CI_STORELIST_MAX_CSV_UPLOAD,
	CIA_BANNER_CAROUSEL,
	CIA_NEW_ACCOUNT_FLYOUT_FALLBACK,
	CIA_NEW_CREATE_LISTS_BUTTON,
	CIA_NEW_CUSTOMER_PORTAL,
	CIA_NEW_CUSTOMER_PORTAL_MENU_CHANGE_NOTIFICATION,
	CIA_REORDER_BUTTON,
	CIA_SAVED_SEARCH,
	CUSTOMER_CATEGORY_GROUP_BANNER_PLACEMENT,
	ENABLE_FIXED_WIDTH_CONTENT,
	ENABLE_NEXTCMS_COOKIE_DISCLAIMER,
	ENABLE_NEXTCMS_FOOTER,
	ENABLE_ORDER_HABITS,
	ENABLE_SIDE_CADDY,
	EV_ALTERNATIVES_POPUP_BEHAVES_INVERSED,
	EV_SHOW_LASTCHANCE_STOCK_COUNTER,
	EV_SHOW_MRPRICE,
	HINTS_ON_I18N,
	LISTPAGE_SORTING_SCORING,
	METRO_X,
	METRO_X_ACCOUNT_SELECT,
	NEW_ARTICLE_BADGE,
	OC_CUSTOMER_SURVEY,
	OC_FSD_DELIVERY_DATE_BEFORE_CHECKOUT,
	SD_ALTERNATIVE_STEMMING,
	SD_BOOST_ARTICLE_ATTRIBUTES,
	SD_BOOST_CUSTOMER_TARGET_GROUPS,
	SD_BOOST_OWN_BRAND,
	SD_BULK_PRICES,
	SD_FOR_DEBUG_ONLY_SHOW_EV_ALTERNATIVES_COMPONENT,
	SD_FSD_FILTER_ALWAYS_ACTIVE_FOR_STORE_DELIVERY_CUSTOMERS,
	SD_NO_INFO_SUGGESTIONS,
	SD_PARTICIPATES_IN_LTR_TEST,
	SD_SHOW_ADD_TO_CART_IN_SUGGESTIONS,
	SD_SHOW_ARTICLLESEARCH_CSAT,
	SD_SHOW_METRO_X_STORE_SELECTOR_CCOV,
	SD_SHOW_METRO_X_STORE_SELECTOR_FSD,
	SD_SHOW_STORE_CUTOFF_TIME_FOR_TRADERS,
	SD_SUBCATEGORIES_PANEL,
	SD_SUBCATEGORIES_PANEL_SEARCHPAGE,
	SD_SUGGEST_CONTENT,
	SD_USE_EXTERNAL_NAVIGATION,
	SD_X_FOR_Y,
	SEARCH_DEBUG,
	SHOW_MERCHANT_OFFER_PAGE,
	SUGGESTIONS_DEBUG,
	TOUCH_SCREEN_UI,
	SD_SHOW_GTINS,
	SD_SHOW_NEW_ADD_TO_CART_COMPONENT_FROM_OC,
} from "../Features";

export function initFeatures() {
	return {
		[ARTICLE_SOURCES_FACET]: {
			defaultGroup: "A",
			description: "Toggles whether to display filter facets for article sources eg. marketplace or not",
			descriptionA: "Don't display these filter facets",
			descriptionB: "Display these filter facets",
		},
		[CA_SHOW_ALTERNATIVES_ALWAYS]: {
			description: "On article badges we show a replacement link that opens a modal with a search.",
			descriptionA: "Only show replacement link if the article is unavailable or delisted.",
			descriptionB: "Show replacement link always.",
		},
		[CA_SHOW_CUSTOMER_ARTICLE_GROUPING_LINK]: {
			description: "Displays matching customer article groups link on customer search tiles.",
			descriptionA: "No, do not display",
			descriptionB: "Yes, display",
		},
		[CA_USE_METROX_ACCOUNT_FLYOUT]: {
			description:
				"Steers the usage of the Metro-X Account Flyout provided by M:Web/NextCms or the flyout of M:Shop (aka business accounts (BA) flyout)",
			descriptionA: "Do not use Metro-X Flyout, use BA flyout",
			descriptionB: "Use the Metro-X Flyout",
		},
		[CI_ARTICLE_BANNER]: {
			defaultGroup: "A",
			description: "Toggles whether to display articles banner configuration",
			descriptionA: "Don't display the banner option",
			descriptionB: "Display the banner option",
		},
		[CI_BLOCK_OLD_TERMS_AND_CONDITIONS_PAGE]: {
			description: "Blocks the old terms and conditions page",
			descriptionA: "Use the legacy terms and conditions page",
			descriptionB: "Block the legacy terms and conditions page",
		},
		[CI_ENABLE_BANNER_FLAVOR]: {
			description: "Toggles whether the banner can use the flavor target parameter",
			descriptionA: "Flavor cannot be used",
			descriptionB: "Flavor can be used",
		},
		[CI_ENABLE_BANNER_GIFS]: {
			description: "Toggles whether the banner can display gifs or not",
			descriptionA: "No gifs allowed",
			descriptionB: "Gifs are enabled",
		},
		[CI_MULTIPLE_CREATIVES]: {
			defaultGroup: "A",
			description: "Toggles whether to allow multiple creatives for banners",
			descriptionA: "Don't allow multiple creatives",
			descriptionB: "Allow multiple creatives",
		},
		[CI_NEW_FOOTER]: {
			description: "Use the new footer imported from sitecore",
			descriptionA: "Use the legacy footer",
			descriptionB: "Use the new shiny footer",
		},
		[CI_NEW_STORELIST_PAGE]: {
			description: "Use the new storelist page",
			descriptionA: "Use the legacy storelist page",
			descriptionB: "Use the new storelist page",
		},
		[CI_SL_CASH_AND_CARRY_VISIBLE]: {
			defaultGroup: "A",
			description: "Toggles whether to add targeting to storelist for cash and carry",
			descriptionA: "targeting for only c&c is not possible",
			descriptionB: "targeting for only c&c is possible",
		},
		[CI_STORELIST_MAX_CSV_UPLOAD]: {
			defaultGroup: "A",
			description: "Toggles whether the csv upload maximum items",
			descriptionA: "Keep the maximum up to 500 articles",
			descriptionB: "Increase the maximum to 1000 articles",
		},
		[CIA_NEW_ACCOUNT_FLYOUT_FALLBACK]: {
			description: "Toggles which enables Account flyout fall back when NEXTCMS flyout does not appear",
			descriptionA: "No fallback",
			descriptionB: "Fallback active",
		},
		[CIA_NEW_CREATE_LISTS_BUTTON]: {
			description: "Toggles which create new personal list button design is used",
			descriptionA: "Show buttons in the lists grid",
			descriptionB: "Show buttons on top of lists",
		},
		[CIA_NEW_CUSTOMER_PORTAL]: {
			description:
				"Toggles which enables New Reduced Customer Portal for MetroX. This feature requires the self service url to be configured in optonal country config. Property name: selfServiceUrl",
			descriptionA: "Old portal",
			descriptionB: "new Portal",
		},
		[CIA_NEW_CUSTOMER_PORTAL_MENU_CHANGE_NOTIFICATION]: {
			description: "Toggles which enables the user to be notified that a new portal menu is available",
			descriptionA: "No notification is displayed",
			descriptionB: "Notification is displayed",
		},
		[CIA_REORDER_BUTTON]: {
			description: "Disable the reorder button",
			descriptionA: "Do not show it",
			descriptionB: "Show the reorder button",
		},
		[CIA_BANNER_CAROUSEL]: {
			description: "Disable the banner carousel functionality",
			descriptionA: "Do not show the banner carousel elements",
			descriptionB: "Show the banner carousel elements",
		},
		[CIA_SAVED_SEARCH]: {
			description: "View saved search collections",
			descriptionA: "deactivate saved search for customers",
			descriptionB: "activate saved search for customers",
		},
		[CUSTOMER_CATEGORY_GROUP_BANNER_PLACEMENT]: {
			defaultGroup: "A",
			description: "Toggles whether customer category groups banner placement is active or not",
			descriptionA: "CCG Placement Inactive",
			descriptionB: "CCG Placement Active",
		},
		[ENABLE_FIXED_WIDTH_CONTENT]: {
			description: "Toggles whether the content of the page should have a fixed width",
			descriptionA: "The content is displayed over the full width of the browser",
			descriptionB: "Limit the width of the content",
		},
		[ENABLE_NEXTCMS_COOKIE_DISCLAIMER]: {
			description: "Toggles whether the NextCMS cookie disclaimer is displayed",
			descriptionA: "normal sitecore disclaimer",
			descriptionB: "new NextCMS webcomponent",
		},
		[ENABLE_NEXTCMS_FOOTER]: {
			description: "Toggles whether the nextCMS footer is used or sitecore footer",
			descriptionA: "normal sitecore footer",
			descriptionB: "new NextCMS webcomponent",
		},
		[ENABLE_ORDER_HABITS]: {
			description: "Toggles customer order habits banner feature",
			descriptionA: "No order habits",
			descriptionB: "Order habits enabled",
		},
		[ENABLE_SIDE_CADDY]: {
			description: "Toggles the display of the SideCaddy and layout of the cart buttons in the navigation bar",
			descriptionA: "Do NOT display the SideCaddy and the new cart buttons",
			descriptionB: "Add the Side Caddy and display the new cart buttons",
		},
		[EV_ALTERNATIVES_POPUP_BEHAVES_INVERSED]: {
			description: "The alternatives popup behaves differently on EV and OC pages.",
			descriptionA: "Everything is normal.",
			descriptionB:
				'(for testing) The popup behaves as if it appears in the cart. This changes the "go back" button among other details',
		},
		[EV_SHOW_LASTCHANCE_STOCK_COUNTER]: {
			description: "Show the Stock Counter for the Last Chance Promotion.",
			descriptionA: "HIDE the stock counter.",
			descriptionB: "SHOW the stock counter.",
		},
		[EV_SHOW_MRPRICE]: {
			description: "Show the MRPrice.",
			descriptionA: "HIDE the MRPrice.",
			descriptionB: "SHOW the MRPrice.",
		},
		[HINTS_ON_I18N]: {
			description: "Enable hints when hovering over a <FormattedMessage/>.",
			descriptionA: "No Hints",
			descriptionB: "With Hints",
		},
		[LISTPAGE_SORTING_SCORING]: {
			description: "Toggles whether sorting based on scoring returned from the personallists service",
			descriptionA: "Defaulting to sorting defined in LISTPAGE_SORTING_LAST_INTERACTION",
			descriptionB: "Sort by scoring of Lists",
		},
		[METRO_X]: {
			description: "Toggles whether the new Metro X design is enabled",
			descriptionA: "disabled",
			descriptionB: "enabled",
		},
		[METRO_X_ACCOUNT_SELECT]: {
			description: "Toggles whether the new Account select page is enabled",
			descriptionA: "disabled",
			descriptionB: "enabled",
		},
		[NEW_ARTICLE_BADGE]: {
			defaultGroup: "B",
			description: "Toggles whether the new article badge design is enabled",
			descriptionA: "disabled",
			descriptionB: "enabled",
		},
		[OC_CUSTOMER_SURVEY]: {
			description: "Show survey after customer checkout",
			descriptionA: "No survey is shown.",
			descriptionB: "The survey is shown.",
		},
		[OC_FSD_DELIVERY_DATE_BEFORE_CHECKOUT]: {
			description:
				"Controls when to show the delivery date and allow its selection for pure FSD carts before checkout process. This is part of Availability to Promise (ATP) epic (see BOC-63192).",
			descriptionA: "Delivery date is set during checkout (old flow as we used to it).",
			descriptionB:
				"Delivery date is selectable before checkout (which implies no longer allowing to change it during checkout)",
		},
		[SD_ALTERNATIVE_STEMMING]: {
			description:
				"Activates an alternative stemming algorithm to be tested for NL (see https://jira.metrosystems.net/browse/MSD-1828)",
			descriptionA: "Use original stemming",
			descriptionB: "Use alternative stemming",
		},
		[SD_BOOST_ARTICLE_ATTRIBUTES]: {
			description: "Boost hits in article attributes like material, form or color; see MSD-1387 for details.",
			descriptionA: "Do not boost attribute hits",
			descriptionB: "Boost attribute hits",
		},
		[SD_BOOST_CUSTOMER_TARGET_GROUPS]: {
			description:
				"Boost search results that match the customer's customer target group (see https://jira.metrosystems.net/browse/MSD-1902)",
			descriptionA: "Do not boost CTGs",
			descriptionB: "Boost CTGs",
		},
		[SD_BOOST_OWN_BRAND]: {
			description: "Boost own brand search results, see MSD-2386.",
			descriptionA: "Standard boosting",
			descriptionB: "Boost own-brand products",
		},
		[SD_BULK_PRICES]: {
			description: "Show DNR badge for Bulk Prices",
			descriptionA: "No, don't show them",
			descriptionB: "Yes, show the Bulk Prices DNR badge",
		},
		[SD_FOR_DEBUG_ONLY_SHOW_EV_ALTERNATIVES_COMPONENT]: {
			description:
				"For debug only as this applies to all Article Card instances shared across M.Shop: Show EV's alternative articles button and component in article card",
			descriptionA: "No, don't show",
			descriptionB: "Yes, show",
		},
		[SD_FSD_FILTER_ALWAYS_ACTIVE_FOR_STORE_DELIVERY_CUSTOMERS]: {
			description:
				"Keeps the FSD filter always active when a customer has FSD enabled for a non-FSD store (see MSD-1521 for details)",
			descriptionA: "Default delivery mode filters",
			descriptionB: "Only FSD filter if customer is FSD-contracted for the current, non-FSD store",
		},
		[SD_NO_INFO_SUGGESTIONS]: {
			description: "Removes 'Info & Services' content suggestions within M|Shop.",
			descriptionA: "Suggest contents and article search queries",
			descriptionB: "Suggest only article search queries",
		},
		[SD_PARTICIPATES_IN_LTR_TEST]: {
			description: "Enable LTR test",
			descriptionA: "Not enabled",
			descriptionB: "Enabled",
		},
		[SD_SHOW_ARTICLLESEARCH_CSAT]: {
			description: "MSD-2053 - Show CSAT Survey for Articlesearch",
			descriptionA: "No, don't show it",
			descriptionB: "Yes, the survey",
		},
		[SD_SHOW_METRO_X_STORE_SELECTOR_CCOV]: {
			description: "Feature toggle to enable new MetroX store selector for CCOV.",
			descriptionA: "Shows standard store selector",
			descriptionB: "Shows store selector provided by MetroX",
		},
		[SD_SHOW_METRO_X_STORE_SELECTOR_FSD]: {
			description: "Feature toggle to enable new MetroX store selector for FSD.",
			descriptionA: "Shows standard store selector",
			descriptionB: "Shows store selector provided by MetroX",
		},
		[SD_SUBCATEGORIES_PANEL]: {
			description: "Show a list of subcategories on the category page",
			descriptionA: "Don't show it",
			descriptionB: "Show it",
		},
		[SD_SUBCATEGORIES_PANEL_SEARCHPAGE]: {
			description:
				"Show a list of subcategories on the search page (see https://jira.metrosystems.net/browse/MSD-1971)",
			descriptionA: "Don't show it",
			descriptionB: "Show it",
		},
		[SD_SUGGEST_CONTENT]: {
			description: "Show content suggestions.",
			descriptionA: "Do not show content suggestions",
			descriptionB: "Show content suggestions",
		},
		[SD_USE_EXTERNAL_NAVIGATION]: {
			description: "Use external navigation component",
			descriptionA: "Don't use it",
			descriptionB: "Use it",
		},
		[SD_X_FOR_Y]: {
			description: "Show x for y promotions",
			descriptionA: "No, don't show them",
			descriptionB: "Yes, Show the promotion badge and text",
		},
		[SEARCH_DEBUG]: {
			description: "Toggles debug helpers for article search",
			descriptionA: "No debugging ",
			descriptionB: "Show debug helpers",
		},
		[SHOW_MERCHANT_OFFER_PAGE]: {
			description: "Add the merchant offer overview page to the merchant page tabs.",
			descriptionA: "No, do not add",
			descriptionB: "Yes, add tab",
		},
		[SUGGESTIONS_DEBUG]: {
			description: "Toggles debug query for suggestions",
			descriptionA: "Don't debug suggestions",
			descriptionB: "Debug suggestions",
		},
		[TOUCH_SCREEN_UI]: {
			description: "Always show touch-screen optimized UI, regardless of whether a touch screen was detected",
			descriptionA: "No, use detection",
			descriptionB: "Yes, always show touch-screen UI",
		},
		[SD_SHOW_ADD_TO_CART_IN_SUGGESTIONS]: {
			description: "Showing the add-to-cart button within the search suggestions",
			descriptionA: "No, don't show them",
			descriptionB:
				"Yes, show the add-to-cart button within the search suggestions for logged-in FSD customers and desktop view only.",
		},
		[SD_SHOW_STORE_CUTOFF_TIME_FOR_TRADERS]: {
			description: "Show the store cutoff time and store cutoff holiday time for traders",
			descriptionA: "No, don't show it",
			descriptionB: "Yes, show the store cutoff time and store cutoff holiday time for traders",
		},
		[SD_SHOW_GTINS]: {
			description: "Show/hide gtins in pdp page",
			descriptionA: "Hide gtins pdp in pdp page",
			descriptionB: "Show gtins in pdp page",
		},
		[SD_SHOW_NEW_ADD_TO_CART_COMPONENT_FROM_OC]: {
			description: "Show/hide add-to-cart component of OC",
			descriptionA: "Hide add-to-cart component of OC",
			descriptionB: "Show add-to-cart component of OC",
		},
	};
}
